module.exports = __webpack_public_path__ + "static/media/delirio-mesa-de-trabajo.e5612e9a.jpg";